module.exports = __webpack_public_path__ + "media/images/content/icon_travel-017bc96be3430bd25fac6ffe542cb773.svg";